import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { appAllGetTeams } from '../../store/teams'
import { teamExportColumns } from '../../config/exportColumns/teamExportColumns'
import TableFilter from './tableFilter'

function Teams() {
	const dispatch = useDispatch()

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Teams</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetTeams({
									...params,
									sanstha: sansthaId || permissionOfSanstha,
									page: 1,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={teamExportColumns}
						fileName="Teams_List"
						sheetName="Teams"
						buttonText="Export Teams"
					/>
				</div>

				<TableFilter />
			</div>
		</>
	)
}

export default Teams
